import {Injectable} from "@angular/core";
import {Headers, Http, RequestOptions, Response} from "@angular/http";

import {Properties} from 'ts-json-properties';

import {BodyService} from "../../shared/utils/body.service";
import {JsonApiService} from "../../core/api/json-api.service";

import "rxjs/add/operator/map";
import {SessionService} from "./session.service";

@Injectable()
export class AuthenticationService {

    datai18nServidor: any ;
    ipFinalServidor: string = "";
    constructor(private http: Http,
                private bodyService: BodyService,
                private jsonApiService: JsonApiService,
                private sessionService: SessionService) { }

    login(username: string, password: string) {

        this.logoin();
        const rutaServidor = localStorage.getItem('rutaServidor');
        const tokenUrl = rutaServidor + "/api/auth";
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: headers });

        return this.http.post(tokenUrl, JSON.stringify({ username: username, password: password }), options)
            .map((response: Response) => {

                let currentToken = JSON.parse(JSON.parse(JSON.stringify(response))._body).token;
                sessionStorage.setItem("token",  currentToken);

                let user = response.json();
                if (user && user.token) {
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    let token = this.bodyService.jwt();
                }

                this.sessionService.login();
            })
            .catch(this.bodyService.handleError);
    }


    logoin() {
        sessionStorage.setItem('sm-fixed-header','true');
        sessionStorage.setItem("defaultLocale", "es");
        sessionStorage.setItem('expiracion','N');
        this.obtenerI18n();

        let data = localStorage.getItem("datai18n");
        this.datai18nServidor = JSON.parse(data);
        this.ipFinalServidor = this.datai18nServidor['servidorIP'];
        localStorage.setItem('rutaServidor',this.ipFinalServidor);
		Promise.all([this.obtenerI18n()]);

    }

    logout() {
        // remove user from local storage to log user out
        this.bodyService.logout();

    }

    private obtenerI18n() {
        let i18n = sessionStorage.getItem("defaultLocale");
        //
        let url = "";
        if (i18n === "es") {
            url = '/langs/es.json';
        }
        else {
            url = '/langs/us.json';
        }
        this.jsonApiService.fetchAjaxSincronoSessionStorage(url,"datai18n");
    }

}


// WEBPACK FOOTER //
// ./src/app/+auth/+login/authentication.service.ts